import axios from 'axios';
import store from '@/store';
import router from '@/router';
import * as JwtUtil from '@/common/JwtUtil';

const baseDomain = process.env.VUE_APP_BASE_URL;
const baseURL = `${baseDomain}/api`;
/**
 * axiosインスタンス生成
 */
const axiosInstance = axios.create({ baseURL });

axiosInstance.interceptors.request.use((request) => {
  const { headers } = request;

  headers['Content-Type'] = 'application/json;charset=utf-8';

  const token = JwtUtil.getJwt();
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return request;
});

// レスポンスをインターセプトしてtokenを管理する
axiosInstance.interceptors.response.use((response) => {
  const { headers } = response;
  const jwt = headers[JwtUtil.JWT_HEADER_NAME];
  if (jwt) {
    JwtUtil.setJwt(jwt);
  }
  return response;
},
(error) => {
  // Tokenがない場合はそのままエラーとする
  const token = JwtUtil.getJwt();
  if (!token) return Promise.reject(error);

  if (error.config && error.response
    && error.response.status === 401 && !store.state.isRefreshed) {
    // refreshToken発行は1回のみのためstoreに記録する
    store.commit('execRefresh', true);
    const config = {
      headers: {
        'x-exam-key': process.env.VUE_APP_EXAM_SECRET_KEY,
      },
    };
    return axiosInstance.post('/account/refresh', null, config)
      .then((response) => {
        JwtUtil.setJwt(response.data.access_token);
        return axiosInstance.request(error.config);
      })
      .catch(() => {
        // JWT再取得NGの場合はJWTを削除
        JwtUtil.deleteJwt();
        router.replace('/');
      })
      .finally(() => {
        store.commit('execRefresh', false);
      });
  }
  return Promise.reject(error);
});

export default axiosInstance;
